import {
  BarGraphIcon,
  BorderIcon,
  FallbackIconCircle,
  GridIcon,
  HorizontalBarGraphIcon,
  LineDiagramIcon,
  LocationIcon,
  PieChartIcon,
  RadarDiagramIcon,
  SplitTableLineDiagram,
  SplitTablePieDiagram,
  SplitTableRecording,
  TableListIcon,
} from '@va/icons';
import { DataViewOption } from '@va/types/report-block';

export function getViewIcon(view: DataViewOption) {
  switch (view) {
    case DataViewOption.lineDiagram:
    case DataViewOption.stackedLineDiagram:
    case DataViewOption.steppedLineDiagram:
      return LineDiagramIcon;
    case DataViewOption.radarDiagram:
      return RadarDiagramIcon;
    case DataViewOption.table:
      return TableListIcon;
    case DataViewOption.barChart:
      return BarGraphIcon;
    case DataViewOption.horizontalBarChart:
      return HorizontalBarGraphIcon;
    case DataViewOption.pieChart:
      return PieChartIcon;
    case DataViewOption.kpi:
      return BorderIcon;
    case DataViewOption.map:
      return LocationIcon;
    case DataViewOption.card:
      return GridIcon;
    case DataViewOption.splitTableLineDiagram:
      return SplitTableLineDiagram;
    case DataViewOption.splitTablePieDiagram:
      return SplitTablePieDiagram;
    case DataViewOption.splitTableRecording:
      return SplitTableRecording;
  }
  return FallbackIconCircle;
}
